export function mainNav() {
    const $window = $(window);
    const $body = this.body;
    const $header = $(".header");
    const menuOpener = $header.find(".menu-opener");
    const mobileSearch = $(".mobile-search .search-btn");
    const desktopSearch = $(".search-desktop .search-btn");
    const desktopSearchField = $header.find("input[type=\"text\"]");
    const desktopSearchClose = $(".search-desktop .close-search");
    mobileSearch.on("click", function () {
        $body.addClass("mobile-search-open");
    });
    desktopSearch.on("click", function () {
        $body.addClass("desktop-search-open");
        setTimeout(() => {
            desktopSearchField.focus();
        }, 200);
    });
    desktopSearchClose.on("click", function () {
        $body.removeClass("desktop-search-open");
    });
    menuOpener.on("click", function () {
        if ($body.hasClass("mobile-search-open")) {
            $body.removeClass("mobile-search-open");
        } else {
            $body.toggleClass("menu-open");
        }
    });

    let className = "filled";
    let mobileSearchForm = ".mobile-search-form";

    $(".mobile-search-form input").focus(function () {
        $(this).parents(mobileSearchForm).addClass(className);
    }).blur(function () {
        let inputIsEmpty = $(this).val().length === 0;
        if (inputIsEmpty) {
            setTimeout(function () {
                $(this).parents(mobileSearchForm).removeClass(className);
            },300);
        }
    });
    $(".reset").on("click", function () {
        $(mobileSearchForm).removeClass(className)
    });
    $(".close-mobile-search").on("click", function () {
        $body.removeClass("mobile-search-open");
        $(".reset").trigger("click");
    });

    $window.on("scroll", function () {
      let allowSticky = true;
      if ($window.scrollTop() > 0 && allowSticky) {
          $header.addClass("sticky");
          allowSticky = false;
      } else {
          $header.removeClass("sticky");
          allowSticky = true;
      }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/mainNav.js